import { GENERAL_SECTION } from "../fields";

const SECTION_CATALOG = [
    {
        key: "specifications",
        label: "Specification Sheets",
        description:
            "The excipient and capsule-shell specification sheets. Each material becomes one specification table.",
    },
];

const SECTIONS = SECTION_CATALOG.map((s) => s.key);

const STEPS = [{ key: "details", title: "Configure" }];

const BLOCK_TITLES = {
    "general:product": "The drug product",
};

const BLOCK_DESCRIPTIONS = {
    "general:product":
        "Which materials are covered, their names, tests and methods are all read from the specification sheets you assign below.",
};

const FIELDS = [
    {
        section: GENERAL_SECTION,
        block: "product",
        group: "p4_specifications",
        name: "drug_product_names",
        label: "Drug Product Name(s)",
        type: "string_list",
        description:
            "The drug product(s) these specifications are written for, as printed in the lead sentence and the page header.",
        required: true,
    },
];

export default {
    id: "p4_specifications",
    steps: STEPS,
    sectionCatalog: SECTION_CATALOG,
    fields: FIELDS,
    blockTitles: BLOCK_TITLES,
    blockSections: {},
    blockDescriptions: BLOCK_DESCRIPTIONS,
    sectionArticleType: {},
    sectionsWithoutDocuments: new Set(),
    optionalSections: new Set(),
    orderedSectionKey: null,
    nonMetadataKeys: new Set(),
    fixedSections: SECTIONS,
    payloadTables: ["p4_specifications"],
    emitsDeviceFamily: false,
    hasArticles: false,
    advisories: () => [],
};
